export function getReportParams() {
    return {
        columns: [{
            field: 'ID',
            width: 80,
            pinned: 'left',
            hideFloatingFilter: true,
        },
        {
            field: 'DocType',
            width: 380,
        },
        {
            field: 'Barcode01',
            width: 200,
        },
        {
            field: 'fileName',
            width: 380,
        },
        {
            field: 'Description',
            width: 300,
        },
        {
            field: 'PosNum',
            width: 170,
        },
        {
            field: 'PO_Num',
            width: 200,
        },
        {
            field: 'InvNum',
            width: 150,
        },
        ],
        sort: 'fileName',
        limit: 5000,
        rowCountPerPage: 50,
        selectedFilters: [],
        selectedColumns: [
            'ID',
            'DocType',
            'Barcode01',
            'fileName',
            'Description',
        ],
    };
}
